import React from "react";
import { getData } from "country-list";
import Flags from "country-flag-icons/react/3x2";
import { Listbox, Transition } from "@headlessui/react";
import { m } from "framer-motion";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { defaultClasses } from "./text-field";

const MultiCountryField = ({
  label,
  required,
  // value,
  className,
  error,
  helperText,
  // onChange,
  animate,
  ...props
}) => {
  const countries = getData();

  var finalClassName = "";
  if (className) {
    const classes = className.split(" ");
    console.log(classes);
    var finalClasses = defaultClasses.split(" ");
    for (const cls of classes) {
      console.log(cls);
      if (cls.includes("h-") || cls.includes("w-") || cls.includes("text-")) {
        //remove the class with the same beginning and add the new class
        finalClasses = finalClasses.filter(
          (c) => !c.includes(cls.split("-")[0]),
        );
        finalClasses.push(cls);
      } else {
        finalClasses.push(cls);
      }
    }
    finalClassName = finalClasses.join(" ");
  } else {
    finalClassName = defaultClasses;
  }

  return (
    <Listbox
      as={animate ? m.div : "div"}
      id="country"
      autoComplete="country"
      // value={value}
      // onChange={onChange}
      {...props}
      className={`relative text-start ${error ? "text-red-500" : "text-auto-black/60"}`}
      animate={animate}
      multiple
    >
      <label className="relative text-sm">
        {label}
        {required && <span className="text-red-500">*</span>}
      </label>
      <div className="relative w-full">
        <Listbox.Button
          className={`${finalClassName} relative flex place-items-center gap-1 overflow-hidden !px-2`}
        >
          {props.value.map((country) => (
            <div
              key={country}
              className="rounded-full bg-secondary px-2 py-1 text-xs text-white"
            >
              {country}
            </div>
          ))}
          <ChevronDownIcon className="absolute inset-y-0 right-2 h-5 w-5 self-center" />
        </Listbox.Button>
      </div>
      {error && !!helperText && <div className="text-xs">{helperText}</div>}
      <Transition
        as={React.Fragment}
        leave="transition ease-in duration-100 origin-top"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-95"
      >
        <Listbox.Options className="absolute z-10 mt-1 max-h-48 w-full overflow-auto rounded bg-auto-white py-1 text-base shadow ring-1 ring-black/5 focus:outline-none sm:text-sm">
          {countries
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((country) => {
              const FlagComponent = Flags[country.code];
              return (
                <Listbox.Option
                  as="div"
                  id={`country-option-${country.code}`}
                  key={country.code}
                  value={country.name}
                  className="flex w-full items-center gap-2 self-stretch p-2 ui-selected:bg-secondary-500/10 ui-selected:font-bold ui-active:bg-primary/20 ui-active:text-primary-900"
                >
                  <FlagComponent width="1.5rem" height="1rem" alt="" />
                  <span>{country.name}</span>
                </Listbox.Option>
              );
            })}
        </Listbox.Options>
      </Transition>
    </Listbox>
  );
};

export default MultiCountryField;
